import { render, staticRenderFns } from "./DatatableVehicleMaster.vue?vue&type=template&id=0d70b8a4"
import script from "./DatatableVehicleMaster.vue?vue&type=script&lang=js"
export * from "./DatatableVehicleMaster.vue?vue&type=script&lang=js"
import style0 from "./DatatableVehicleMaster.vue?vue&type=style&index=0&id=0d70b8a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports